import { render, staticRenderFns } from "./Webapp.vue?vue&type=template&id=8163baf2&"
import script from "./Webapp.vue?vue&type=script&lang=js&"
export * from "./Webapp.vue?vue&type=script&lang=js&"
import style0 from "./Webapp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Webapp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8163baf2')) {
      api.createRecord('8163baf2', component.options)
    } else {
      api.reload('8163baf2', component.options)
    }
    module.hot.accept("./Webapp.vue?vue&type=template&id=8163baf2&", function () {
      api.rerender('8163baf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Webapp.vue"
export default component.exports